import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { Ban } from '@src/data/types'
import { useTranslation } from 'react-i18next'

interface UnbanConfirmationDialogProps {
  open: boolean
  ban: Ban | null
  onClose: () => void
  onConfirm: (id: string) => void
}

const UnbanConfirmationDialog: React.FC<UnbanConfirmationDialogProps> = ({ open, ban, onClose, onConfirm }) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    if (ban) {
      onConfirm(ban.id)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('banishments.unban.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {ban
            ? t('banishments.unban.confirmMessage', {
                name: `${ban.firstName} ${ban.lastName}`,
              })
            : ''}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button onClick={handleConfirm} variant="contained" color="error">
          {t('banishments.unban.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnbanConfirmationDialog
